<!--
  单页自定义模板组件
  用法：template 指定 pages/components/ 下的模板文件名
  - 查看：FReport detail 模式渲染到页面内
  - 编辑：点击编辑按钮 → FReport edit 模式内嵌切换
-->
<style lang="less">
  .fan-curd-modal {
    :deep(.arco-modal-header) { padding: 15px 20px; }
    :deep(.arco-modal-body) { max-height: 800px; padding: 20px; overflow-x: hidden; overflow-y: auto; }
  }
</style>
<style lang="less" scoped>
  @import "~@/public/less/index.less";
  .f-plugin-single-tpl {
    width: 100%; height: 100% !important; overflow: hidden;
    .head {
      padding: 20px;
      font-size: 1.1em; font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .head-title {
        flex: 1;
        cursor: pointer;
        &:hover { color: rgb(var(--primary-6)); }
      }

      .head-actions {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;
        margin-left: 20px;
      }
    }

    /* 编辑模式 */
    .edit-body {
      height: 100%;
      overflow-y: auto;
      padding: 20px;
      background-color: var(--card-bg, #fff);
    }

    /* 查看模式：模板内容区 */
    .view-body {
      height: 100%;
      overflow-y: auto;
      padding: 20px;
      background-color: var(--card-bg, #fff);
    }
  }
</style>

<template>
  <div class="fan fan-component f-plugin-single-tpl">
    <f-layout ref="flayout"
              v-if="superApi && template"
              :superPage="page"
              :superApi="api"
              @reloadData="reloadData">
      <!-- 头部：标题 + 操作按钮 -->
      <template #head v-if="superTitle">
        <div class="head">
          <span class="head-title" @click="$fan.page.open(returnUrl.url, returnUrl.query)">
            {{ superTitle || router.info.name }}
          </span>
          <div class="head-actions">
            <!-- 编辑模式切换 -->
            <a-button v-if="!editing"
                      type="primary"
                      size="small"
                      @click="bindStartEdit">
              <icon-edit /> 编辑
            </a-button>
            <template v-else>
              <a-button size="small" @click="bindCancelEdit">取消</a-button>
              <a-button type="primary" status="success" size="small" @click="bindSaveEdit">
                <icon-check /> 保存
              </a-button>
            </template>
          </div>
        </div>
      </template>

      <!-- 子菜单（仅 5 级以上菜单显示） -->
      <template #menus v-if="menus && Object.keys(menus).length > 1 && !editing && router.info.level >= 5">
        <a-menu mode="inline"
                :style="{ height: '100%', borderRight: 0 }"
                :defaultOpenKeys="[`${router.topInfo.url}`]"
                :defaultSelectedKeys="[`${router.info.url}`]">
          <template v-for="(item, index) in menus">
            <a-sub-menu :key="index"
                        v-if="item.info.show &&
                              item.info.type === 'menu' &&
                              item.info.level === (router.navInfo.level + 1) &&
                              !item.info.hasTmp && item.info.hasChild">
              <template #title>
                <component :is="'icon-' + item.info.icon" />
                <span>{{ item.info.name }}</span>
              </template>
              <template v-for="(item2, index2) in menus">
                <a-menu-item :key="index2"
                             v-if="item2.info.type === 'menu' &&
                                   item2.topInfo.url === item.info.url &&
                                   item2.info.level === (router.navInfo.level + 2)"
                             @click="$fan.page.open(index2, query)">
                  <span>
                    <component :is="'icon-' + item2.info.icon" />
                    <span>{{ item2.info.name }}</span>
                  </span>
                </a-menu-item>
              </template>
            </a-sub-menu>
            <a-menu-item :key="'menu-' + index"
                         v-else-if="item.info.show &&
                                    item.info.level === (router.navInfo.level + 1) &&
                                    item.info.hasTmp"
                         @click="$fan.page.open(index, query)">
              <span>
                <component :is="'icon-' + item.info.icon" />
                <span>{{ item.info.name }}</span>
              </span>
            </a-menu-item>
          </template>
        </a-menu>
      </template>

      <!-- 正文内容 -->
      <template #body>
        <!-- 查看模式：自定义模板详情（等数据加载完再渲染 FReport） -->
        <div v-if="!editing && dataLoaded" class="view-body" ref="viewBody">
          <f-report ref="freportDetail"
                    :superApi="superApi"
                    :superData="data"
                    :template="template"
                    mold="detail"
                    :mixData="mixData"
                    @emitOpenDrawer="bindOpenDrawer"
                    @emitCloseDrawer="bindCloseDrawer"
                    @emitReloadData="bindReloadData" />
        </div>

        <!-- 编辑模式：自定义模板表单 -->
        <div v-else-if="editing" class="edit-body" ref="editBody">
          <f-report ref="freportForm"
                    :superApi="superApi"
                    :superData="data"
                    :template="template"
                    mold="edit"
                    :mixData="mixData"
                    @bindFormSubmit="bindFormSubmit"
                    @emitOpenDrawer="bindOpenDrawer"
                    @emitCloseDrawer="bindCloseDrawer"
                    @emitReloadData="bindReloadData" />
        </div>

        <!-- 加载中占位 -->
        <div v-else style="padding:40px;text-align:center;color:#86909c;">
          数据加载中...
        </div>
      </template>
    </f-layout>
  </div>
</template>

<script>
import { IconEdit, IconCheck } from '@arco-design/web-vue/es/icon'

export default {
  name: 'FPluginSingleTemplate',
  components: { IconEdit, IconCheck },
  props: {
    superTitle: String,
    superApi: String,
    template: String,
    mixData: Object,
    superColumns: Array,
    superQuery: Array
  },
  created() {
    this.page = this.$fan.utils.parse(this.def.page)
    this.data = this.$fan.utils.parse(this.def.data)
    // 提前初始化 store，确保 FReport mounted 时数据已就绪
    this.prepareStoreColumns()
  },
    async mounted() {
      await this.initPage()
    },
    async activated() {
      await this.initPage()
    },
  computed: {
    routers() {
      return this.$store.state.routers || {}
    },
    router() {
      return this.routers[this.$route.path] || {}
    },
    menus() {
      let menus = {}
      if (this.router && this.router.navInfo && this.router.navInfo.hasChild) {
        for (let k in this.routers) {
          const router = this.routers[k]
          let routerNavUrl = ""
          for (let i = 0; i < this.router.navInfo.level; i++) {
            routerNavUrl = routerNavUrl + "/" + router.info.path[i]
          }
          if (router.info.type !== 'nav' && routerNavUrl === this.router.navInfo.url) {
            menus[router.info.url] = router
          }
        }
      }
      return Object.keys(menus).length > 0 ? menus : false
    },
    query() {
      const q = this.$route.query
      return (q && this.$fan.utils.notEmpty(q)) ? q : false
    },
    api() {
      let api = this.superApi.split('?')
      if (this.superQuery && this.query) {
        let queryArr = []
        for (var k in this.query) {
          if (this.superQuery.indexOf(k) > -1) {
            queryArr.push(`${k}=${this.query[k]}`)
          }
        }
        let qs = queryArr.join('&')
        return api.length > 1 ? `${this.superApi}&${qs}` : `${this.superApi}?${qs}`
      }
      return this.superApi
    },
    returnUrl() {
      const breadcrumb = (this.router.info && this.router.info.breadcrumb) || []
      if (breadcrumb.length > 2) {
        let ret = { name: "首页", icon: "home", url: "/", query: {} }
        // 从后往前找第一个 hasTmp 的页面作为返回目标
        for (let i = breadcrumb.length - 2; i >= 0; i--) {
          const url = breadcrumb[i].url
          if (this.routers[url] && this.routers[url].info && this.routers[url].info.hasTmp) {
            ret = breadcrumb[i]
            break
          }
        }
        let retQuery = this.$fan.utils.parse(this.query)
        if (this.superQuery) {
          delete retQuery[this.superQuery]
        }
        ret.query = retQuery
        return ret
      }
      return { name: "首页", icon: "home", url: "/", query: {} }
    }
  },
  data() {
    return {
      editing: false,
      dataLoaded: false,   // 标记数据是否加载完成
      data: {},
      page: {},
      def: {
        data: {},
        page: {
          initing: false,
          loading: false,
          filter: {
            page: 1,
            limit: 1
          }
        }
      }
    }
  },
  methods: {
    async initPage() {
      if (this.superApi && this.template) {
        if (this.superQuery) {
          if (this.query && Object.keys(this.query).length > 0) {
            this.reloadData()
          }
        } else {
          this.reloadData()
        }
      } else {
        this.$message.warning('页面模板未设置必要参数（superApi/template）')
      }
    },
    /* 将 superColumns 转换为 FReport 需要的格式，写入 store */
    prepareStoreColumns() {
      if (!this.superColumns) return
      const columns = {}
      for (const col of this.superColumns) {
        if (col.dataIndex) {
          columns[col.dataIndex] = {
            name: col.title,
            form: col.form || 'input',
            type: col.type || 'text',
            hidden: col.hidden || false,
            required: col.required || false,
            disabled: col.disabled || false,
            placeholder: col.placeholder || '',
            setting: col.setting || {},
            options: col.options || []
          }
        }
      }
      // 初始化 store.page 完整结构（FReport.loadData 依赖 page.columns + page.keyinfo）
      this.$store.state.page = {
        ...this.$store.state.page,
        columns: columns,
        keyinfo: this.$store.state.page.keyinfo || {},
        options: this.$store.state.page.options || {}
      }
    },

    async loadData() {
      this.page.loading = true
      this.dataLoaded = false
      try {
        // 先准备好 store 中的 columns（FReport.loadData 依赖它）
        this.prepareStoreColumns()
        const { data: res } = await this.$fan.api.get(this.api, this.page.filter)
        this.data = res.data ? res.data[0] : null
        this.$store.state.page.data = res

        // 数据加载完成，允许渲染 FReport
        this.dataLoaded = true
      } catch (e) {
        console.error('加载数据失败:', e)
        this.$message.error('数据加载失败')
      }
      this.page.loading = false
    },

    /* 刷新当前模式下的 FReport */
    refreshFReport() {
      const ref = this.editing ? 'freportForm' : 'freportDetail'
      if (this.$refs[ref] && this.$refs[ref].loadData) {
        this.$refs[ref].loadData()
      }
    },

    async reloadData() {
      this.page.initing = true
      this.page.filter = this.$fan.utils.parse(this.def.page.filter)
      await this.loadData()
      await this.$fan.page.loadCallback(this.superColumns, this.data)
      this.page.initing = false
    },

    /* ========== 编辑相关 ========== */
    bindStartEdit() {
      this.editing = true
      this.$nextTick(() => {
        if (this.$refs.freportForm) {
          this.$refs.freportForm.loadData && this.$refs.freportForm.loadData()
        }
      })
    },

    async bindSaveEdit() {
      if (!this.$refs.freportForm) return
      try {
        await this.$refs.freportForm.actionFormSubmit()
        this.editing = false
      } catch (e) {
        console.error('保存失败:', e)
      }
    },

    bindCancelEdit() {
      this.editing = false
      this.reloadData()
    },

    /* ========== FReport 回调转发 ========== */
    bindOpenDrawer(title, record) {
      this.$refs.flayout.bindOpenCurd(title, record)
    },
    bindCloseDrawer() {
      this.$refs.flayout.bindCloseDrawer()
    },
    bindReloadData() {
      this.reloadData()
    },

    /* ========== 表单提交回调 ========== */
    bindFormSubmit(mold, form) {
      // 提交 API 请求
      const apiBase = this.api.split('?')[0]
      const id = this.data ? this.data.id : null

      this.doSubmit(apiBase, id, form)
    },

    async doSubmit(apiBase, id, form) {
      if (id) {
        // 编辑
        const { data } = await this.$fan.api.put(`${apiBase}/${id}`, form)
        if (data && data.data) {
          // API 层已通过拦截器提示 success，此处不再重复提示
          this.editing = false
          this.reloadData()
        }
      } else {
        // 新增（一般单页不会走到这里）
        const { data } = await this.$fan.api.post(`${apiBase}`, form)
        if (data && data.data) {
          this.editing = false
          this.reloadData()
        }
      }
    }
  }
}
</script>
